/**
 * Query keys for React Query cache management of notifications
 * Centralized query key factory for notifications
 */

import type { NotificationListParams } from '../types';

export const notificationKeys = {
  all: ['notifications'] as const,
  lists: () => [...notificationKeys.all, 'list'] as const,
  list: (params?: NotificationListParams) => [...notificationKeys.lists(), params] as const,
  unreadCount: (app?: string) => [...notificationKeys.all, 'unread-count', app] as const,
  preferences: () => [...notificationKeys.all, 'preferences'] as const,
};
